import React, { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import FormInput from '@/component/common/form/input';
import { ListSubheader, MenuItem } from '@material-ui/core';
import localStorageUtil from '@/common/utils/localStorageUtil';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import {
    getListGuestProject,
    getListProjectInCorporationForDelegate
} from '@/service/projectService';
import {
    getFormOfProjectDelegate,
    handleOnchangeFormDelegateAndTask,
    onSelectGuestUser,
    onSelectProjectDelegate,
    sortLabelByDictionaryASC
} from './handler/DelegateTicketHandler';
import { getProjectLabel } from './handler/QaTicketHandler';
import { I18n } from 'aws-amplify';
import './DelegateTicket.css';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import _, { cloneDeep } from 'lodash';
import { getFormFromFormListById } from './handler/TicketHandler';
import PropTypes from 'prop-types';

DelegateTicket.propTypes = {
    detailTicket: PropTypes.object,
    setGuestProjectSelected: PropTypes.func,
    displayMode: PropTypes.any,
    isDraftMode: PropTypes.any,
    registerCreateTicket: PropTypes.any,
    setIsLoading: PropTypes.any,
    getValuesCreateTicket: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    currentPanelInitData: PropTypes.any,
    guestProjectSelected: PropTypes.any,
    guestUserListByProject: PropTypes.any,
    guestUserSelected: PropTypes.any,
    formList: PropTypes.any,
    errorCreateTicket: PropTypes.any,
    selectedForm: PropTypes.any,
    corporationDetail: PropTypes.any,
    setGuestProjectList: PropTypes.func,
    // Add other props validations as needed
};

export default function DelegateTicket(props) {
    const corporationId = localStorageUtil.getAffiliationOrganization();
    const isDisableDelegateFields =
        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
        props?.displayMode === Constant.DISPLAY_MODE.VIEW;
    const optionDelegateType = {
        INTERNAL: 1,
        EXTERNAL: 2
    };

    const [isOpenSelectProject, setIsOpenSelectProject] = useState(false);
    const [corporationProjectList, setCorporationProjectList] = useState([]);
    const [customerProjectList, setCustomerProjectList] = useState([]);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const isDisplayOptionsDelegate = (projectInuse, optionType, listOptions) => {
        if (Utils.isEmptyArray(listOptions)) return false;
        let result = false;

        if (optionType === optionDelegateType.INTERNAL) {
            result = !Utils.isProjectGuestDesk(projectInuse);
        } else {
            result =
                Utils.isProjectGuestDesk(projectInuse) ||
                Utils.isPublicDesk(projectInuse) ||
                (Utils.isPrivateDesk(projectInuse) &&
                    props?.isDraftMode &&
                    !Utils.isEmptyArray(customerProjectList));
        }

        return result;
    };

    const [customerUserList, setCustomerUserList] = useState([]);
    const isInitDataTicketDraft = props.isDraftMode && !props.currentPanelInitData?.argsAll;
    const isDeskOnPublicOffSendDraft = Utils.isPrivateDesk(projectInuseDetail) &&
        props?.isDraftMode && props.detailTicket;

    useEffect(() => {
        props.registerCreateTicket('selectedForm');
        props.registerCreateTicket('corporationOrigin');
        props.registerCreateTicket('fileUploadList');

        // get customer project of corporation
        props.setIsLoading(true);

        let currentCorporationProjectList = [];
        let currentCustomerProjectList = [];
        getListProjectInCorporationForDelegate(props?.API, corporationId)
            .then(resProjectList => {
                if (resProjectList) {
                    let baseProject = {};
                    let guestCustomerProject = {};
                    let delegateProjectList = [];
                    for (const project of resProjectList) {
                        if (
                            project.id !== props.projectInuseDetail.id &&
                            ![Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(
                                project.type
                            )
                        ) {
                            delegateProjectList.push(project);
                        }

                        if (project.type === Constant.PROJECT_TYPE.BASE) {
                            baseProject = Utils.updateNewDisplayNameOfProject(project, Constant.PROJECT_BASE_DISPLAY_NAME);
                        }
                        if (project.type === Constant.PROJECT_TYPE.CUSTOMER) {
                            guestCustomerProject = project;
                        }
                    }

                    // Sort delegate project list
                    // Set list prj in corp
                    delegateProjectList = Utils.sortListByNameDictionaryASC(delegateProjectList);
                    currentCorporationProjectList = [baseProject].concat(delegateProjectList);
                    currentCorporationProjectList = currentCorporationProjectList.filter(project => project.active === Constant.ACTIVE_FLAG.ACTIVE);
                    setCorporationProjectList(currentCorporationProjectList);

                    getListGuestProject(props?.API, props.projectInuseDetail)
                        .then(async result => {
                            // List customer of prj
                            let listCustomerPoject = result.listProjectDetail;
                            listCustomerPoject = sortLabelByDictionaryASC(listCustomerPoject);
                            currentCustomerProjectList = listCustomerPoject;
                            if (!Utils.isEmptyObject(guestCustomerProject)) {
                                currentCustomerProjectList = [guestCustomerProject].concat(
                                    currentCustomerProjectList
                                );
                            }

                            if (isDeskOnPublicOffSendDraft) {
                                let detailTicket = props.detailTicket;
                                let selectedProjectId = detailTicket.projectOrigin;
                                let selectedProjectDetail = currentCustomerProjectList.find(project => project.id === selectedProjectId);
                                if (selectedProjectDetail) {
                                    currentCustomerProjectList = [selectedProjectDetail];
                                }
                                currentCustomerProjectList = !!selectedProjectDetail
                                    ? [ selectedProjectDetail ]
                                    : [];
                            }

                            setCustomerProjectList(currentCustomerProjectList);
                            let allGuestProject = currentCorporationProjectList.concat(currentCustomerProjectList);
                            props.setGuestProjectList(allGuestProject);
                            
                            // Ticket draft
                            if (isInitDataTicketDraft) {
                                let detailTicket = props.detailTicket;
                                let selectedProjectId = detailTicket.projectOrigin;
                                let selectedProjectDetail = allGuestProject.find(project => project.id === selectedProjectId);
                                if (selectedProjectDetail && !Utils.isEmptyObject(selectedProjectDetail)) {
                                    props.setGuestProjectSelected(selectedProjectDetail);
                                    let cloneArgsAll = cloneDeep(props);
                                    cloneArgsAll.guestProjectList = allGuestProject;
                                    let initProjectRes = await onSelectProjectDelegate(selectedProjectDetail.id, props, false);
                                    if (detailTicket.proxiedUser) {
                                        onSelectGuestUser(
                                            detailTicket.proxiedUser,
                                            props,
                                            initProjectRes,
                                            true
                                        )
                                    }
                                }
                            }

                            if (!isInitDataTicketDraft) {
                                let userDetail = props.userDetail;
                                let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                                let lastFormOfProject = workLastForm[projectInuseDetail.id];
                                let switchFormId = props?.selectedForm ? props.selectedForm : '';
                                if (
                                    !Utils.isEmptyObject(props?.currentPanelInitData?.formData) &&
                                    props?.currentPanelInitData?.formData?.selectedForm &&
                                    Utils.isEmptyString(switchFormId)
                                ) {
                                    switchFormId = props?.currentPanelInitData?.formData?.selectedForm;
                                }
                                if (lastFormOfProject) {
                                    let lastFormDelegateOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_DELEGATE];
                                    if (!Utils.isEmptyObject(lastFormDelegateOfProject)) {
                                        // Validate Form
                                        let selectedFormDetail = await getFormFromFormListById(
                                            lastFormDelegateOfProject.formId
                                        );
                                        let isLastFormNotValid = Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(projectInuseDetail.id);
                    
                                        if (!isLastFormNotValid && !switchFormId) {
                                            switchFormId = lastFormDelegateOfProject?.formId;
                                        }
                                    }
                                }

                                if (switchFormId) {
                                    let e = {
                                        target: {
                                            value: switchFormId
                                        }
                                    }
                                    handleOnchangeFormDelegateAndTask(e, {
                                        ...props,
                                        selectedForm: '',
                                        typeOfTicket: Constant.TICKET_TYPE.DELEGATE

                                    })
                                }
                            }

                            props.setIsLoading(false);
                        })
                        .catch(err => {
                            props.setGuestProjectList(
                                currentCorporationProjectList.concat([guestCustomerProject])
                            );
                            setCustomerProjectList([guestCustomerProject]);
                            props.setIsLoading(false);
                        });
                } else {
                    props.setIsLoading(false);
                    props.setGuestProjectList([]);
                }
            })
            .catch(err => {
                props.setIsLoading(false);
                props.setGuestProjectList([]);
            });

        if (props.isInitOldData || isInitDataTicketDraft) return;
        getFormOfProjectDelegate(props);
        
    }, [props?.projectInuseDetail]); // re-query when change prj type

    useEffect(() => {
        if (!props.guestUserListByProject || Utils.isEmptyArray(props.guestUserListByProject)) {
            setCustomerUserList([]);
            return;
        }
        let newUserList = _.orderBy(props.guestUserListByProject, ['label', 'name'], ['asc', 'asc']);
        setCustomerUserList(newUserList);
    }, [props.guestUserListByProject]);

    const isDisplaySelectDelegateUser = () => {
        if (!Utils.isEmptyString(props.getValuesCreateTicket('projectId')) || !Utils.isEmptyObject(props.guestProjectSelected)) {
            return true;
        }
        return false;
    }

    return (
        <div className="groupCreate-main helpdesk-create-delegate">
            <div className="headeCreate">
                <div className="headeCreate-form">
                    <div className="headeCreate-flex">
                        <div className="headeCreate-title">代理プロジェクト</div>
                        <div className="headeCreate-info">
                            <FormInput
                                className="form-control form-control--wrap form-control--hg40"
                                select
                                variant="outlined"
                                name="projectId"
                                value={
                                    props.guestProjectSelected.id
                                        ? props.guestProjectSelected.id
                                        : ''
                                }
                                defaultValue={
                                    props.guestProjectSelected.id
                                        ? props.guestProjectSelected.id
                                        : ''
                                }
                                required
                                errorlist={props.errorCreateTicket}
                                SelectProps={{
                                    value: props.guestProjectSelected?.id ? props.guestProjectSelected.id : '',
                                    open: isOpenSelectProject,
                                    onClose: e => setIsOpenSelectProject(false),
                                    onOpen: e => setIsOpenSelectProject(true),
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                disabled={isDisableDelegateFields}
                            >
                                {Utils.isEmptyArray(corporationProjectList) &&
                                    Utils.isEmptyArray(customerProjectList) && (
                                        <MenuItem style={{ display: 'none' }}></MenuItem>
                                    )}

                                {/* corporationProjectList */}
                                {isDisplayOptionsDelegate(
                                    projectInuseDetail,
                                    optionDelegateType.INTERNAL,
                                    corporationProjectList
                                ) && (
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('USER04BTN007')}
                                    </ListSubheader>
                                )}
                                {isDisplayOptionsDelegate(
                                    projectInuseDetail,
                                    optionDelegateType.INTERNAL,
                                    corporationProjectList
                                ) &&
                                    corporationProjectList?.map(projectInternal => {
                                        return (
                                            <MenuItem
                                                key={`delegate-project-internal-${projectInternal?.id}`}
                                                value={projectInternal?.id}
                                                data-cy="qa-ticket-item-contact-desk"
                                                onClick={() => {
                                                    onSelectProjectDelegate(
                                                        projectInternal?.id,
                                                        props
                                                    );
                                                    setIsOpenSelectProject(false);
                                                }}
                                            >
                                                <OverFlowTooltipWithTabsMui
                                                    value={Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        projectInternal.name
                                                    )}
                                                />
                                            </MenuItem>
                                        );
                                    })}

                                {/* customerProjectList */}
                                {isDisplayOptionsDelegate(
                                    projectInuseDetail,
                                    optionDelegateType.EXTERNAL,
                                    customerProjectList
                                ) && (
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('USER04BTN033')}
                                    </ListSubheader>
                                )}

                                {isDisplayOptionsDelegate(
                                    projectInuseDetail,
                                    optionDelegateType.EXTERNAL,
                                    customerProjectList
                                ) &&
                                    customerProjectList?.map(projectExternal => {
                                        let label = '';

                                        if (
                                            projectExternal.type === Constant.PROJECT_TYPE.CUSTOMER
                                        ) {
                                            label = Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                projectExternal.name
                                            );
                                        } else {
                                            label = getProjectLabel(
                                                projectExternal,
                                                props.corporationDetail
                                            );
                                        }

                                        return (
                                            <MenuItem
                                                key={`delegate-project-external-${projectExternal?.id}`}
                                                value={projectExternal?.id}
                                                data-cy="qa-ticket-item-contact-desk"
                                                style={isDeskOnPublicOffSendDraft
                                                    ? { opacity: 0.8, color: '#a9a9a9', cursor: 'default' }
                                                    : undefined
                                                }
                                                onClick={() => {
                                                    if (isDeskOnPublicOffSendDraft) return;
                                                    onSelectProjectDelegate(
                                                        projectExternal?.id,
                                                        props
                                                    );
                                                    setIsOpenSelectProject(false);
                                                }}
                                            >
                                                <OverFlowTooltipWithTabsMui value={label} />
                                            </MenuItem>
                                        );
                                    })}
                            </FormInput>

                            {isDisplaySelectDelegateUser() && (
                                <div className="selectUser">
                                    <div className="selectUser-title">投稿者</div>
                                    <div className="selectUser-info">
                                        <FormInput
                                            name="guestUserId"
                                            select
                                            className="form-control form-control--wrap form-control--hg40"
                                            variant="outlined"
                                            options={props.guestUserListByProject}
                                            required
                                            errorlist={props.errorCreateTicket}
                                            value={props.guestUserSelected?.id ? props.guestUserSelected?.id : ''}
                                            defaultValue={props.guestUserSelected?.id ? props.guestUserSelected?.id : ''}
                                            onClick={e => {
                                                let userIdSelected = e.target?.value;
                                                onSelectGuestUser(
                                                    userIdSelected,
                                                    props,
                                                    props.guestUserListByProject
                                                )
                                            }}
                                            SelectProps={{
                                                value: props.guestUserSelected?.id ? props.guestUserSelected?.id : '',
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: 'bottom',
                                                        horizontal: 'left'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'left'
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: 'selectDrop'
                                                }
                                            }}
                                            disabled={isDisableDelegateFields}
                                        >
                                            {customerUserList.map(item => {
                                                return (
                                                    <MenuItem key={`user-for-delegate-${item.id}`} value={item.id}>
                                                        <OverFlowTooltipWithTabsMui value={item.label} />
                                                    </MenuItem>
                                                );
                                            })}
                                        </FormInput>
                                    </div>
                                </div>
                            )}

                            {!Utils.isEmptyArray(props.guestUserListByProject) &&
                            !Utils.isEmptyObject(props.guestUserSelected) ? (
                                <div className="headeCreate-acc">
                                    <div className="headeCreate-text">
                                        <p className="name">
                                            {Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                props.guestUserSelected.lastName
                                            )}{' '}
                                            {Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                props.guestUserSelected.firstName
                                            )}{' '}
                                        </p>
                                    </div>
                                    <div className="headeCreate-thumb">
                                        <img src={props.guestUserSelected.avatar} alt="" />
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="scrollBar-main">
                <div className="addTicket">
                    <div className="form-addTicket">
                        <label className="form-addTicket-label">フォーマット</label>
                        <div className="form-addTicket-input">
                            <FormInput
                                className="form-control form-control--wrap form-control--hg40"
                                select
                                variant="outlined"
                                name="selectedForm"
                                value={props.selectedForm ? props.selectedForm : ''}
                                defaultValue={props.selectedForm ? props.selectedForm : ''}
                                onClick={e => {
                                    handleOnchangeFormDelegateAndTask(e, {...props,typeOfTicket: Constant.TICKET_TYPE.DELEGATE});
                                    e.stopPropagation();
                                }}
                                required
                                errorlist={props.errorCreateTicket}
                                SelectProps={{
                                    value: props.selectedForm ? props.selectedForm : '',
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                disabled={isDisableDelegateFields}
                            >
                                {!Utils.isEmptyArray(props.formList) &&
                                    props.formList?.map(item => {
                                        return (
                                            <MenuItem key={item.id} value={item.id}>
                                                <OverFlowTooltipWithTabsMui 
                                                    value={Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        item.name
                                                    )} 
                                                />
                                            </MenuItem>
                                        );
                                    })}
                            </FormInput>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
